/// <reference path="../../Common/Base/SiteEntityGrid.ts" />

namespace Matrix.Data {
    
    @Serenity.Decorators.registerClass()
    export class SecurityOverrideGrid extends SiteEntityGrid<SecurityOverrideRow, any> {
        protected getColumnsKey() { return 'Data.SecurityOverride'; }
        protected getDialogType() { return SecurityOverrideDialog; }
        protected getIdProperty() { return SecurityOverrideRow.idProperty; }
        protected getLocalTextPrefix() { return SecurityOverrideRow.localTextPrefix; }
        protected getService() { return SecurityOverrideService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}